import React, { useState } from "react";
import { FaSearch, FaFilter, FaEdit, FaWhatsapp } from "react-icons/fa";
import "../../styles/common/index.css"; // Common styles (PageLayout, ActionBar, FilterForm)
import "./DisbursalSendBack.css"; // Page-specific styles (Table, etc.)

const DisbursalSendBack = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [showFilterForm, setShowFilterForm] = useState(false);
  const [formKey, setFormKey] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  
  // Filter form state
  const [filterData, setFilterData] = useState({
    leadId: "",
    leadSource: "",
    state: "",
    city: "",
    branch: "",
    userType: "",
    fromDate: "",
    toDate: "",
    firstName: "",
    mobileNo: "",
    emailId: "",
    pan: "",
    loanNo: "",
    docsAvailable: "",
    sanctionManager: "",
    sancFromDate: "",
    sancToDate: "",
  });

  const toggleFilterForm = () => {
    setShowFilterForm(!showFilterForm);
  };

  const handleFilterChange = (field, value) => {
    setFilterData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleFilterSearch = () => {
    // TODO: Implement search functionality with backend
    console.log("Filter Data:", filterData);
    setShowFilterForm(false);
  };

  const handleFilterReset = () => {
    console.log("Reset button clicked!");
    
    const emptyData = {
      leadId: "",
      leadSource: "",
      state: "",
      city: "",
      branch: "",
      userType: "",
      fromDate: "",
      toDate: "",
      firstName: "",
      mobileNo: "",
      emailId: "",
      pan: "",
      loanNo: "",
      docsAvailable: "",
      sanctionManager: "",
      sancFromDate: "",
      sancToDate: "",
    };
    
    setFilterData({ ...emptyData });
    setFormKey(prev => prev + 1);
    
    console.log("Reset completed! Data:", emptyData);
  };

  const handleRowSelect = (id) => {
    setSelectedRows((prev) => {
      if (prev.includes(id)) {
        return prev.filter((rowId) => rowId !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectedRows.length === applications.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(applications.map((app) => app.id));
    }
  };

  // Dummy data - later replace with actual API data
  const applications = [
    {
      id: 1,
      leadId: "5215",
      appliedOn: "28-11-2025 13:20",
      source: "DHANWALLE",
      name: "PRIYA SHARMA",
      state: "RAJASTHAN",
      city: "JAIPUR",
      branch: "JAIPUR",
      mobile: "9876543213",
      pan: "PQRST3456U",
      userType: "NEW",
      status: "DISBURSAL-SEND-BACK",
      sanctionManager: "NEHA PATEL",
      sanctionedOn: "28-11-2025 15:20",
      sanctionedAmount: "55,000",
    },
    {
      id: 2,
      leadId: "5205",
      appliedOn: "28-11-2025 14:30",
      source: "DHANWALLE",
      name: "VIKAS SINGH",
      state: "UTTAR PRADESH",
      city: "LUCKNOW",
      branch: "LUCKNOW",
      mobile: "9876543212",
      pan: "KLMNO9012P",
      userType: "REPEAT",
      status: "DISBURSAL-SEND-BACK",
      sanctionManager: "RAHUL YADAV",
      sanctionedOn: "28-11-2025 16:45",
      sanctionedAmount: "80,000",
    },
  ];

  return (
    <div className="page-wrapper">
      {/* Page Header */}
      <div className="page-header-section">
        <div className="page-title-section">
          <h1 className="page-title">Disbursal Send Back</h1>
          <p className="page-subtitle">Manage and track disbursal applications that have been sent back</p>
        </div>
        <div className="count-display">
          <span className="count-number">{applications.length}</span>
          <span className="count-label">Total Leads</span>
        </div>
      </div>

      {/* Action Bar */}
      <div className="action-bar">
        <div className="search-filter-group">
          <div className="search-input-wrapper">
            <FaSearch className="search-input-icon" />
            <input
              type="text"
              placeholder="Search applications by name, mobile, PAN..."
              className="search-input"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <button className="filter-button" onClick={toggleFilterForm}>
            <FaFilter />
            Filters
          </button>
        </div>
        <div className="action-buttons">
          <button className="primary-action-btn">Export</button>
          <button className="primary-action-btn">Add New Application</button>
        </div>
      </div>

      {/* Filter Form Section */}
      {showFilterForm && (
        <div className="filter-form-section" key={formKey}>
          <form className="filter-form-container" onSubmit={(e) => e.preventDefault()}>
            {/* First Row */}
            <div className="filter-form-row">
              <div className="filter-form-field">
                <label>Lead ID</label>
                <input
                  type="text"
                  value={filterData.leadId}
                  onChange={(e) => handleFilterChange("leadId", e.target.value)}
                  placeholder="Enter Lead ID"
                />
              </div>
              <div className="filter-form-field">
                <label>Lead Source</label>
                <select
                  value={filterData.leadSource}
                  onChange={(e) => handleFilterChange("leadSource", e.target.value)}
                >
                  <option value="">SELECT</option>
                  <option value="dhanwalle">DHANWALLE</option>
                  <option value="website">Website</option>
                  <option value="referral">Referral</option>
                </select>
              </div>
              <div className="filter-form-field">
                <label>State</label>
                <select
                  value={filterData.state}
                  onChange={(e) => handleFilterChange("state", e.target.value)}
                >
                  <option value="">SELECT</option>
                  <option value="west-bengal">West Bengal</option>
                  <option value="telangana">Telangana</option>
                  <option value="maharashtra">Maharashtra</option>
                  <option value="gujarat">Gujarat</option>
                </select>
              </div>
              <div className="filter-form-field">
                <label>City</label>
                <select
                  value={filterData.city}
                  onChange={(e) => handleFilterChange("city", e.target.value)}
                >
                  <option value="">SELECT</option>
                  <option value="kolkata">Kolkata</option>
                  <option value="hyderabad">Hyderabad</option>
                  <option value="mumbai">Mumbai</option>
                  <option value="pune">Pune</option>
                </select>
              </div>
              <div className="filter-form-field">
                <label>Branch</label>
                <select
                  value={filterData.branch}
                  onChange={(e) => handleFilterChange("branch", e.target.value)}
                >
                  <option value="">SELECT</option>
                  <option value="branch1">Branch 1</option>
                  <option value="branch2">Branch 2</option>
                  <option value="hyderabad">Hyderabad</option>
                </select>
              </div>
              <div className="filter-form-field">
                <label>User Type</label>
                <select
                  value={filterData.userType}
                  onChange={(e) => handleFilterChange("userType", e.target.value)}
                >
                  <option value="">SELECT</option>
                  <option value="new">New</option>
                  <option value="existing">Existing</option>
                  <option value="repeat">Repeat</option>
                </select>
              </div>
            </div>

            {/* Second Row */}
            <div className="filter-form-row">
              <div className="filter-form-field">
                <label>From Date</label>
                <input
                  type="date"
                  value={filterData.fromDate}
                  onChange={(e) => handleFilterChange("fromDate", e.target.value)}
                />
              </div>
              <div className="filter-form-field">
                <label>To Date</label>
                <input
                  type="date"
                  value={filterData.toDate}
                  onChange={(e) => handleFilterChange("toDate", e.target.value)}
                />
              </div>
              <div className="filter-form-field">
                <label>Sanc From Date</label>
                <input
                  type="date"
                  value={filterData.sancFromDate}
                  onChange={(e) => handleFilterChange("sancFromDate", e.target.value)}
                />
              </div>
              <div className="filter-form-field">
                <label>Sanc To Date</label>
                <input
                  type="date"
                  value={filterData.sancToDate}
                  onChange={(e) => handleFilterChange("sancToDate", e.target.value)}
                />
              </div>
              <div className="filter-form-field">
                <label>First Name</label>
                <input
                  type="text"
                  value={filterData.firstName}
                  onChange={(e) => handleFilterChange("firstName", e.target.value)}
                  placeholder="Enter First Name"
                />
              </div>
              <div className="filter-form-field">
                <label>Mobile No</label>
                <input
                  type="tel"
                  value={filterData.mobileNo}
                  onChange={(e) => handleFilterChange("mobileNo", e.target.value)}
                  placeholder="Enter Mobile No"
                />
              </div>
            </div>

            {/* Third Row */}
            <div className="filter-form-row">
              <div className="filter-form-field">
                <label>Email ID</label>
                <input
                  type="email"
                  value={filterData.emailId}
                  onChange={(e) => handleFilterChange("emailId", e.target.value)}
                  placeholder="Enter Email ID"
                />
              </div>
              <div className="filter-form-field">
                <label>PAN</label>
                <input
                  type="text"
                  value={filterData.pan}
                  onChange={(e) => handleFilterChange("pan", e.target.value)}
                  placeholder="Enter PAN"
                />
              </div>
              <div className="filter-form-field">
                <label>Loan No</label>
                <input
                  type="text"
                  value={filterData.loanNo}
                  onChange={(e) => handleFilterChange("loanNo", e.target.value)}
                  placeholder="Enter Loan No"
                />
              </div>
              <div className="filter-form-field">
                <label>Sanction Manager</label>
                <input
                  type="text"
                  value={filterData.sanctionManager}
                  onChange={(e) => handleFilterChange("sanctionManager", e.target.value)}
                  placeholder="Enter Sanction Manager"
                />
              </div>
              <div className="filter-form-field">
                <label>Docs Available?</label>
                <select
                  value={filterData.docsAvailable}
                  onChange={(e) => handleFilterChange("docsAvailable", e.target.value)}
                >
                  <option value="">SELECT</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="filter-form-actions">
              <button type="button" className="filter-search-btn" onClick={(e) => { e.preventDefault(); handleFilterSearch(); }}>
                SEARCH
              </button>
              <button type="button" className="filter-reset-btn" onClick={(e) => { e.preventDefault(); handleFilterReset(); }}>
                RESET
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Data Table Section */}
      <div className="data-table-section">
        <table className="leads-data-table">
          <thead>
            <tr>
              <th>Lead ID</th>
              <th>
                <input
                  type="checkbox"
                  className="row-checkbox"
                  checked={selectedRows.length === applications.length && applications.length > 0}
                  onChange={handleSelectAll}
                />
                Action
              </th>
              <th>Applied On</th>
              <th>Source</th>
              <th>Name</th>
              <th>State</th>
              <th>City</th>
              <th>Branch</th>
              <th>Mobile</th>
              <th>PAN</th>
              <th>User Type</th>
              <th>Status</th>
              <th>Sanction Manager</th>
              <th>Sanctioned-On</th>
              <th>Sanctioned-Amount</th>
            </tr>
          </thead>
          <tbody>
            {applications.length === 0 ? (
              <tr>
                <td colSpan="15" className="empty-state-cell">
                  <div className="empty-state">
                    <div className="empty-state-icon">📋</div>
                    <h3 className="empty-state-title">No Applications Found</h3>
                    <p className="empty-state-message">
                      There are no disbursal send back applications at the moment.
                    </p>
                  </div>
                </td>
              </tr>
            ) : (
              applications.map((application) => (
                <tr key={application.id}>
                  <td className="lead-id-cell">{application.leadId}</td>
                  <td className="action-cell">
                    <div className="action-buttons-cell">
                      <input
                        type="checkbox"
                        className="row-checkbox"
                        checked={selectedRows.includes(application.id)}
                        onChange={() => handleRowSelect(application.id)}
                      />
                      <button 
                        className="icon-button edit-btn" 
                        title="Edit"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          console.log("Edit application:", application.id);
                          // TODO: Open edit modal/form
                        }}
                      >
                        <FaEdit />
                      </button>
                      <button 
                        className="icon-button whatsapp-btn" 
                        title="WhatsApp"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          const message = `Hello ${application.name}, regarding your application.`;
                          const whatsappUrl = `https://wa.me/91${application.mobile}?text=${encodeURIComponent(message)}`;
                          window.open(whatsappUrl, '_blank');
                        }}
                      >
                        <FaWhatsapp />
                      </button>
                    </div>
                  </td>
                  <td className="applied-on-cell">{application.appliedOn}</td>
                  <td className="source-cell">{application.source}</td>
                  <td className="name-cell">{application.name}</td>
                  <td className="state-cell">{application.state}</td>
                  <td className="city-cell">{application.city}</td>
                  <td className="branch-cell">{application.branch}</td>
                  <td className="mobile-cell">{application.mobile}</td>
                  <td className="pan-cell">{application.pan}</td>
                  <td className="user-type-cell">
                    <span className={`user-type-badge ${application.userType.toLowerCase()}`}>
                      {application.userType === "NEW" ? "NEW!!" : application.userType}
                    </span>
                  </td>
                  <td>
                    <span className="status-indicator disbursal-send-back">{application.status}</span>
                  </td>
                  <td className="sanction-manager-cell">{application.sanctionManager}</td>
                  <td className="sanctioned-on-cell">{application.sanctionedOn}</td>
                  <td className="sanctioned-amount-cell">{application.sanctionedAmount}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DisbursalSendBack;
